import { Injectable } from '@angular/core';
import { Path } from '@authority-labs/enums';
import { FilesService } from '../files/files.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(private filesService: FilesService) {}

  viewFile(fileId: string, path?: string): void {
    this.openWebUrl(fileId, path);
  }

  viewFolder(folderId: string, path?: string): void {
    this.openWebUrl(folderId, path);
  }

  getLinkToEntity(entity: string, entityId: number): string[] {
    const path = {
      Project: Path.Projects,
      SubProject: Path.Subprojects,
      Order: Path.Orders,
      Company: Path.Companies
    };

    return ['/', 'app', path[entity], entityId];
  }

  private openWebUrl(id: string, path?: string): void {
    this.filesService.getWebUrl(id, path).subscribe({
      next: (response) => {
        const win = window.open(response.webUrl, '_blank');
        if (win) {
          win.focus();
        }
      },
      error: (error) => {
        console.error(`Failed to get web URL for ${id}:`, error);
      }
    });
  }
}
